import { render, staticRenderFns } from "./socket_order.vue?vue&type=template&id=48d055fd&scoped=true&"
import script from "./socket_order.vue?vue&type=script&lang=js&"
export * from "./socket_order.vue?vue&type=script&lang=js&"
import style0 from "./socket_order.vue?vue&type=style&index=0&id=48d055fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d055fd",
  null
  
)

export default component.exports